import React, { useEffect, useState } from "react";
import "./styles.scss";
import "react-notifications-component/dist/theme.css";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import {
  Button,
  DatePickerComponent,
  DropBox,
  FormHeader,
  ImageComponent,
  InputBox,
  KeywordCheckBox,
  PDFPreviewer,
  PDFUploader,
  RadioButton,
  Tag,
  Uploader,
} from "../../../components";
import JobsSelectBox from "../../templates/jobsSelectBox";
import GazetteDateSelectBox from "../../templates/gazetteDateSelectBox";
import { CheckValidity } from "../../../utils/formValidity";
import { Store } from "react-notifications-component";
import { useDispatch, useSelector } from "react-redux";
import Scrollbars from "react-custom-scrollbars-2";
import moment from "moment";
import TagsSelectBox from "../../templates/tagsSelectBox";
import {
  createNewJob,
  createNewJobMulti,
  updateJobs,
} from "./service/jobs.service";
import { deleteImage } from "../../../components/imageComponent/service/upload.service";
import { openCreateTagModal } from "../../Tags/redux/actions";
import { clearedSelectJobs } from "../../Jobs/redux/actions";
import { Editor } from "react-draft-wysiwyg";
import { convertToRaw, ContentState, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { DatePicker, Space } from "antd";
import htmlToDraft from "html-to-draftjs";
import { getNewsKeywords } from "../../news/service/news.service";
import { getLanguage } from "../../../utils";
import { set } from "immutable";

const language = getLanguage();
const CreateNewJob = (props) => {
  const dispatch = useDispatch();
  const [viewPointWidth, setViewPointWidth] = useState(0);
  const [viewPointHeight, setViewPointHeight] = useState(0);
  const [useLanguage, setUseLanguage] = useState(language);

  const { selectJobs, jobCategoryList } = useSelector(
    ({ jobsReducer }) => jobsReducer
  );

  const { datePickData } = useSelector(({ datePicker }) => datePicker);

  const [formData, setFormData] = useState({
    organization: {
      key: "organization",
      label: "Organization",
      size: "lg",
      placeholder: "-",
      mainLayerStyles: " flex-column " + " align-content-center " + "mb-3",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [{ value: "", displayValue: "-- Select Category --" }],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    jobTitleEN: {
      key: "jobTitleEN",
      label: "Job Title - EN",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
      mainLayerStyles: "mb-2",
    },
    jobTitleSI: {
      key: "jobTitleSI",
      label: "Job Title - SI",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
      mainLayerStyles: "mb-2",
    },

    imageUrl: {
      key: "imageUrl",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "Type your image URL",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    keyWord: {
      key: "keyWord",
      label: "",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
      mainLayerStyles: "mb-3",
    },

    description: {
      key: "description",
      label: "Description",
      size: "lg",
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },

    closingDate: {
      key: "closingDate",
      label: "Closing Date",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "YYYY-MM-DD",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
      mainLayerStyles: "mb-2",
    },

    sourceURL: {
      key: "sourceURL",
      label: "Source URL",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
      mainLayerStyles: "mb-2",
    },
    gazetteDate: {
      key: "gazetteDate",
      label: "Gazette Date",
      size: "lg",
      placeholder: "-",
      mainLayerStyles: " flex-column " + " align-content-center " + "mb-3",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [{ value: "", displayValue: "-- Select Gazette Date --" }],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    contactNo: {
      key: "contactNo",
      label: "Contact No",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
      mainLayerStyles: "mb-2",
    },
    email: {
      key: "email",
      label: "Email",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "*******@gmail.com",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
      mainLayerStyles: "mb-2",
    },
    jobApplicationType: {
      key: "jobApplicationType",
      label: "Job Application Type",
      size: "lg",
      placeholder: "-- Select Type --",
      mainLayerStyles: " flex-column " + " align-content-center " + "mb-3",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [
          { value: "1", displayValue: "Download" },
          { value: "2", displayValue: "Online" },
          { value: "3", displayValue: "Model" },
        ],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [suggestion, setSuggestions] = useState([]);
  const [selectKeyword, setSelectKeyword] = useState("");
  const [selectTagList, setSelectTagList] = useState([]);
  const [selectedTagList, setSelectedTagList] = useState([]);
  // const [closingDate, setClosingDate] = useState(null);

  const [image, setImage] = useState({
    si_url: [],
    en_url: [],
    ta_url: [],
  });

  const [bannerImage, setBannerImage] = useState({});
  const [jobApplication, setJobApplication] = useState({
    si_url: "",
    en_url: "",
  });

  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
    const updateNewsForm = {
      ...formData,
      description: {
        ...formData.description,
        value: draftToHtml(convertToRaw(editorState.getCurrentContent())),
      },
    };
    setFormData(updateNewsForm);
  };

  const handleChange = async (event, inputIdentity) => {
    const updateForm = {
      ...formData,
    };

    updateForm[inputIdentity].value = event;
    let validityRes = await CheckValidity(
      inputIdentity,
      updateForm[inputIdentity].value,
      updateForm[inputIdentity].validation
    );

    if (validityRes) {
      updateForm[inputIdentity].isValid = validityRes.isValid;
      updateForm[inputIdentity].invalidReason = validityRes.reason;
      updateForm[inputIdentity].value = event;
      updateForm[inputIdentity].touched = true;

      let formIsValid = false;
      for (let inputIdentifier in updateForm) {
        formIsValid = updateForm[inputIdentifier].valid && formIsValid;
      }
      setFormData(updateForm);
    }
  };

  // scrollbars start
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    window.addEventListener("scroll", handleOnScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener("scroll", handleOnScroll);
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  const updateWindowDimensions = () => {
    setViewPointWidth(window.innerWidth);
    setViewPointHeight(window.innerHeight);
  };

  const handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
  };
  // scrollbars end

  useEffect(() => {
    if (datePickData?.date) {
      const updatedForm = {
        ...formData,
      };
      updateForm.closingDate.value = datePickData.date;
      setFormData(updatedForm);
    }
  }, [datePickData]);

  const onChangeBannerImage = (imageData) => {
    setBannerImage(imageData);
  };

  const onChangeJobApplication = (imageData, type) => {
    try {
      if (type === "si") {
        setJobApplication((prev) => ({
          ...prev,
          si_url: imageData?.file_url,
        }));
      }
      if (type === "en") {
        setJobApplication((prev) => ({
          ...prev,
          en_url: imageData?.file_url,
        }));
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
    // setJobApplication(imageData.file_url);
    // console.log("job application", imageData.file_url);
  };

  const onChangeImage = (imageData, type) => {
    try {
      if (type === "si") {
        console.log("si", image.si_url);
        setImage((prev) => ({
          ...prev,
          si_url: [...prev.si_url, imageData],
        }));
      }
      if (type === "en") {
        setImage((prev) => ({
          ...prev,
          en_url: [...prev.en_url, imageData],
        }));
      }
      if (type === "ta") {
        setImage((prev) => ({
          ...prev,
          ta_url: [...prev.ta_url, imageData],
        }));
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const tagsSelect = (tags) => {
    setSelectTagList(tags);
  };

  const onClickRemoveImage = async (key, type, imageType) => {
    setIsLoading(true);
    console.log(key);
    try {
      if (key?.includes("http")) {
        setBannerImage("");
        setIsLoading(false);
        Store.addNotification({
          title: "Success",
          message: "Image Delete successfully",
          type: "success",
          container: "top-right",
          dismiss: {
            duration: 2000,
            onScreen: true,
          },
        });
        return;
      }
      const res = await deleteImage(key);
      console.log("remove image", res);
      if (imageType === "image") {
        if (type === "si") {
          setImage((prev) => ({
            ...prev,
            si_url: prev.si_url?.filter((item) => item.file_name !== key) || [],
          }));
        } else if (type === "en") {
          setImage((prev) => ({
            ...prev,
            en_url: prev.en_url?.filter((item) => item.file_name !== key) || [],
          }));
        } else {
          setImage((prev) => ({
            ...prev,
            ta_url: prev.ta_url?.filter((item) => item.file_name !== key) || [],
          }));
        }
      }
      if (imageType === "jobApplication") {
        if (type === "si") {
          setJobApplication((prev) => ({
            ...prev,
            si_url: "",
          }));
        } else if (type === "en") {
          setJobApplication((prev) => ({
            ...prev,
            en_url: "",
          }));
        }
      }
      if (imageType === "bannerImage") {
        setBannerImage("");
      }
      Store.addNotification({
        title: "Success",
        message: "Image Delete successfully",
        type: "success",
        container: "top-right",
        dismiss: {
          duration: 2000,
          onScreen: true,
        },
      });
      setIsLoading(false);
    } catch (error) {
      console.log("Error in deleting image", error);
      Store.addNotification({
        title: "Error",
        message: "Image Delete failed",
        type: "danger",
        container: "top-right",
        dismiss: {
          duration: 2000,
          onScreen: true,
        },
      });
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  // const onChangeDate = (date, dateString) => {
  //   console.log(date, dateString);
  //   setClosingDate(dateString);
  // };

  useEffect(() => {
    if (selectJobs?.job_id) {
      const updatedForm = {
        ...formData,
      };
      updateForm["jobTitleEN"].value = selectJobs?.job_title?.en;
      updateForm["jobTitleSI"].value = selectJobs?.job_title?.si;
      // updateForm["closingDate"].value = moment(selectJobs?.closing_date).format(
      //   "YYYY-MM-DD"
      // );
      updateForm.keyWord.value = selectJobs?.keywords;
      updateForm.description.value = selectJobs?.description;
      const description = htmlToDraft(selectJobs?.description);
      setEditorState(EditorState.createEmpty());

      if (description && description.contentBlocks) {
        const contentState = ContentState.createFromBlockArray(
          description.contentBlocks
        );
        setEditorState(EditorState.createWithContent(contentState));
      }

      // updateForm["closingDate"].value = moment(selectJobs?.closing_date).format(
      //   "YYYY-MM-DD"
      // );
      updateForm["closingDate"].value = selectJobs?.closing_date;
      updateForm["organization"].value = selectJobs?.organization;
      updateForm["gazetteDate"].value = selectJobs?.gazette_date;
      updateForm["sourceURL"].value = selectJobs?.source_url;
      updateForm["contactNo"].value = selectJobs?.contact_no;
      updateForm["email"].value = selectJobs?.email;
      updateForm["jobApplicationType"].value = selectJobs?.job_application_type;
      setBannerImage(selectJobs.banner_img);

      if (!Array.isArray(selectJobs?.job_details?.si_url)) {
        if (selectJobs?.job_details?.si_url === "") {
          setImage((prev) => ({
            ...prev,
            si_url: [],
          }));
          return;
        }
        let fileName = selectJobs?.job_details?.si_url?.replace(
          "https://hopeofanewera.s3.ap-southeast-1.amazonaws.com/",
          ""
        );
        setImage((prev) => ({
          ...prev,
          si_url: [
            { file_name: fileName, file_url: selectJobs.job_details?.si_url },
          ],
        }));
      } else if (!Array.isArray(selectJobs?.job_details?.en_url)) {
        if (selectJobs?.job_details?.en_url === "") {
          setImage((prev) => ({
            ...prev,
            en_url: [],
          }));
          return;
        }
        let fileName = selectJobs?.job_details?.en_url?.replace(
          "https://hopeofanewera.s3.ap-southeast-1.amazonaws.com/",
          ""
        );
        setImage((prev) => ({
          ...prev,
          en_url: [
            { file_name: fileName, file_url: selectJobs?.job_details?.en_url },
          ],
        }));
      } else if (!Array.isArray(selectJobs?.job_details?.ta_url)) {
        if (selectJobs?.job_details?.ta_url === "") {
          setImage((prev) => ({
            ...prev,
            ta_url: [],
          }));
          return;
        }
        let fileName = selectJobs?.job_details?.ta_url?.replace(
          "https://hopeofanewera.s3.ap-southeast-1.amazonaws.com/",
          ""
        );
        setImage((prev) => ({
          ...prev,
          ta_url: [
            { file_name: fileName, file_url: selectJobs.job_details?.ta_url },
          ],
        }));
      } else {
        setImage(selectJobs.job_details);
      }
      setJobApplication(selectJobs.job_application);
      setSelectedTagList(selectJobs?.tags || []);

      setFormData(updatedForm);
    } else {
      for (let key in updateForm) {
        updateForm[key].value = "";
        updateForm[key].isValid = false;
        updateForm[key].touched = false;
      }
      setFormData(updateForm);
      clearAll();
    }
  }, [selectJobs]);

  const categorySelect = (value) => {
    const updateForm = { ...formData };
    updateForm["organization"].value = value;
    setFormData(updateForm);
  };

  const gazetteDateSelect = (value) => {
    console.log({ value });
    const updateForm = { ...formData };
    updateForm["gazetteDate"].value = value;
    setFormData(updateForm);
  };

  const clearAll = () => {
    const updateForm = {
      ...formData,
    };
    for (let key in updateForm) {
      // console.log(updateForm[key]);
      updateForm[key].value = "";
      updateForm[key].isValid = false;
      updateForm[key].touched = false;
    }

    setImage({
      si_url: [],
      en_url: [],
      ta_url: [],
    });
    setBannerImage("");
    setSelectTagList([]);
    setSelectedTagList([]);
    setJobApplication({
      si_url: "",
      en_url: "",
    });
    setFormData(updateForm);
    setEditorState(EditorState.createEmpty());
    props.refresh(true);
    // setIsButtonDisabled(true);
    // setIsLoading(false);
  };

  useEffect(() => {
    if (formData?.organization?.value && jobCategoryList?.length > 0) {
      let categoryLogo = jobCategoryList.find(
        (category) => category.job_category_id === formData.organization.value
      )?.logo;

      let file = {
        file_url: categoryLogo,
        file_name: categoryLogo?.replace(
          "https://hopeofanewera.s3.ap-southeast-1.amazonaws.com/",
          ""
        ),
      };

      setBannerImage(file);
    }
  }, [formData.organization.value]);

  const onClickSave = async () => {
    setIsLoading(true);
    setIsButtonDisabled(true);

    const updateForm = { ...formData };
    try {
      let body = {
        banner_img: bannerImage,
        job_title: {
          en: updateForm.jobTitleEN.value,
          si: updateForm.jobTitleSI.value,
        },
        keywords: updateForm.keyWord.value,
        description: updateForm.description.value,
        // closing_date: moment(updateForm.closingDate.value).format(
        //   "YYYY-MM-DDTHH:mm:ss.SSSZ"
        // ),
        closing_date: updateForm.closingDate.value,
        organization: updateForm.organization.value,
        source_url: updateForm.sourceURL.value,
        tags: selectTagList,
        gazette_date: updateForm.gazetteDate.value,
        contact_no: updateForm.contactNo.value,
        email: updateForm.email.value,
        job_details: image,
        job_application_type: updateForm.jobApplicationType.value,
        job_application: jobApplication,
      };

      if (useLanguage === "multi") {
        await createNewJobMulti(body);
      }

      const res = await createNewJob();
      console.log("res", res);
      setIsLoading(false);

      if (res?.data) {
        Store.addNotification({
          title: "Success",
          message: "Job created successfully",
          type: "success",
          container: "top-right",
          dismiss: {
            duration: 2000,
            onScreen: true,
          },
        });
        setIsLoading(false);
        setIsButtonDisabled(false);
        clearAll();
      }
    } catch (error) {
      console.error("Error creating job:", error);
      Store.addNotification({
        title: "Error",
        message: "Failed to create job",
        type: "danger",
        container: "top-right",
        dismiss: {
          duration: 2000,
          onScreen: true,
        },
      });
      setIsLoading(false);
    }
  };

  const onClickUpdate = async () => {
    setIsLoading(true);
    setIsButtonDisabled(true);
    try {
      if (selectJobs?.job_id) {
        const updateForm = { ...formData };

        const body = {
          banner_img: bannerImage,
          job_title: {
            en: updateForm.jobTitleEN.value,
            si: updateForm.jobTitleSI.value,
          },
          // closing_date: moment(updateForm.closingDate.value).format(
          //   "YYYY-MM-DDTHH:mm:ss.SSSZ"
          // ),
          keywords: updateForm.keyWord.value,
          description: updateForm.description.value,
          closing_date: updateForm.closingDate.value,
          organization: updateForm.organization.value,
          source_url: updateForm.sourceURL.value,
          tags: selectTagList,
          gazette_date: updateForm.gazetteDate.value,
          contact_no: updateForm.contactNo.value,
          email: updateForm.email.value,
          job_details: image,
          job_application: jobApplication,
          job_application_type: updateForm.jobApplicationType.value,
        };
        const response = await updateJobs(body, selectJobs?.job_id);
        console.log("jobs", response);
        setIsLoading(false);

        if (response?.data) {
          console.log("Jobs Category Updated Successfully");
          // dispatch(updateJobCategory(response?.data));

          Store.addNotification({
            title: "Success!",
            message: "Jobs Updated Successfully!",
            type: "success",
            insert: "top",
            container: "top-right",
            dismiss: { duration: 3000, onScreen: true },
          });
          setIsLoading(false);
          setIsButtonDisabled(false);
          clearAll();
        }
      }
    } catch (error) {
      console.log("Error updating Jobs");
      Store.addNotification({
        title: "Error!",
        message: "Jobs Update Failed!",
        type: "danger",
        insert: "top",
        container: "top-right",
        dismiss: { duration: 3000, onScreen: true },
      });
      setIsLoading(false);
      setIsButtonDisabled(false);
      clearAll();
    }
  };

  const onClickAdd = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    const updateForm = { ...formData };
    if (updateForm.imageUrl.value === "") {
      setIsLoading(false);
      return;
    }
    let file = {
      file_url: updateForm.imageUrl.value,
      file_name: updateForm.imageUrl.value?.replace(
        "https://hopeofanewera.s3.ap-southeast-1.amazonaws.com/",
        ""
      ),
    };

    setBannerImage(file);
    setFormData({
      ...formData,
      imageUrl: {
        ...formData.imageUrl,
        value: "",
        isValid: false,
        touched: false,
      },
    });
    setIsLoading(false);
  };

  const generateKeywords = async () => {
    setIsLoading(true);
    const updateNewsForm = { ...formData };
    try {
      const body = {
        title: updateNewsForm.jobTitleEN.value,
      };
      const response = await getNewsKeywords(body, "en");
      console.log({ response });
      if (response?.data?.status) {
        setSuggestions(response?.data?.data);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const fetchCategoryName = (id) => {
    const isExist = jobCategoryList?.find((x) => x?.job_category_id === id);
    return isExist?.jobs_category_name;
  };

  const fetchApplicationType = (id) => {
    const updateForm = { ...formData };
    const isExist =
      updateForm?.jobApplicationType?.elementConfig?.options?.find(
        (x) => x?.value === id
      );
    return isExist?.displayValue;
  };

  const updateForm = { ...formData };

  return (
    <>
      <div className="hne-create-job-wrapper">
        <FormHeader
          data={{
            formHeader: "Create New Job",
            size: "md-md",
          }}
        />
        <Scrollbars
          onScroll={handleOnScroll}
          renderView={(props) => (
            <div {...props} style={{ ...props.style, overflowX: "hidden" }} />
          )}
          style={{ height: viewPointHeight - 260 }}
        >
          <div
            style={{
              paddingBottom: "32px",
              paddingRight: "16px",
            }}
          >
            <>
              <div className={"hne-cnw-radio-button-wrapper d-flex mb-3"}>
                <RadioButton
                  data={{
                    name: "Multiple",
                    isActive: useLanguage === "multi",
                  }}
                  onClick={() => {
                    setUseLanguage(useLanguage === "multi" ? "" : "multi");
                  }}
                />
              </div>
              <JobsSelectBox
                onChangeCategory={categorySelect}
                data={{
                  type: "organization",
                }}
              />
              {selectJobs?.organization && updateForm.organization.value && (
                <div className="d-flex mt-2">
                  <Tag
                    data={{
                      type: "pending",
                      tagName: fetchCategoryName(updateForm.organization.value),
                    }}
                  />
                </div>
              )}
              <div className={"hne-cjw-uploader-lable"}>Banner</div>
              <div className="d-flex flex-row align-items-center justify-content-between mb-2">
                <InputBox
                  data={updateForm.imageUrl}
                  onChange={async (e) => {
                    e.preventDefault();
                    await handleChange(e.target.value, updateForm.imageUrl.key);
                  }}
                />
                <div className="d-flex ml-2">
                  <Button
                    data={{
                      btnName: "Add",
                      buttonType: "secondary",
                      buttonSize: "md",
                      isLoading: isLoading,
                      disable:
                        updateForm.imageUrl.value === "" ||
                        !updateForm.imageUrl.isValid,
                    }}
                    onClick={async (e) => {
                      e.preventDefault();
                      await onClickAdd(e);
                    }}
                  />
                </div>
              </div>
              <div
                className={"d-flex flex-row align-items-center "}
                style={{ gap: "5px" }}
              >
                {bannerImage && (
                  <>
                    <ImageComponent
                      data={{
                        size: "md mt-3",
                        imgUrl: bannerImage?.file_url,
                      }}
                      onClickRemove={() => {
                        console.log("selectJobs", selectJobs);
                        if (selectJobs?.job_id) {
                          setBannerImage("");
                        } else {
                          onClickRemoveImage(
                            bannerImage?.file_name,
                            "si",
                            "bannerImage"
                          );
                        }
                      }}
                    />
                  </>
                )}

                {/* <Uploader
                  data={{
                    disabled: false,
                    isLable: true,
                    // uploaderLable: "Banner image (1000x 720)",
                    iconName: "upload-cloud",
                  }}
                  onChange={onChangeBannerImage}
                /> */}
              </div>
              <InputBox
                data={updateForm.jobTitleEN}
                onChange={async (e) => {
                  e.preventDefault();
                  await handleChange(e.target.value, updateForm.jobTitleEN.key);
                }}
              />
              {(language === "si" || useLanguage === "multi") && (
                <InputBox
                  data={updateForm.jobTitleSI}
                  onChange={async (e) => {
                    e.preventDefault();
                    await handleChange(
                      e.target.value,
                      updateForm.jobTitleSI.key
                    );
                  }}
                />
              )}

              <div className="suggestions_key">
                {(language === "si" || useLanguage === "multi") && (
                  <div className="txt-label">Sinhala Keyword Suggestions</div>
                )}

                {language === "en" && (
                  <>
                    <Button
                      data={{
                        btnName: "GENERATE KEYWORD",
                        buttonType: "black-border mr-2 mb-3",
                        buttonSize: "lg",
                        isLoading: isLoading,
                        disable:
                          updateForm.jobTitleEN.value === ""
                            ? "black-border disabled mr-2 mb-3"
                            : "",
                      }}
                      onClick={async () => {
                        console.log("clicked...");
                        await generateKeywords();
                      }}
                    />

                    <div className="suggestion_key">
                      <div className="sk_title">
                        English Keyword Suggestions
                      </div>

                      {Array.isArray(suggestion) && suggestion.length > 0
                        ? suggestion.map((item) => (
                            <KeywordCheckBox
                              data={{
                                keyword: item,
                                isSelect: selectKeyword === item,
                              }}
                              onClick={() => {
                                let updatedForm = { ...formData };
                                updatedForm.keyWord.value = item?.replace(
                                  / /g,
                                  "-"
                                );
                                setSelectKeyword(item);
                              }}
                            />
                          ))
                        : ""}
                    </div>
                  </>
                )}
              </div>

              <InputBox
                data={updateForm.keyWord}
                onChange={async (e) => {
                  e.preventDefault();
                  await handleChange(e.target.value, updateForm.keyWord.key);
                }}
              />
              {updateForm.keyWord.value && (
                <div className="news-url">
                  {language === "si" || useLanguage === "multi"
                    ? "https://sinhala.hopeofanewera.org/" +
                      updateForm.keyWord.value
                    : "https://hopeofanewera.org/" + updateForm.keyWord.value}
                </div>
              )}

              <label className={"txt-label"}>
                Description <b>*</b>
              </label>

              <div className={"rich-text-editor-wrapper"}>
                <Editor
                  editorState={editorState}
                  wrapperClassName="demo-wrapper"
                  editorClassName="demo-editor"
                  onEditorStateChange={onEditorStateChange}
                  toolbar={{
                    fontFamily: {
                      options: ["gothambook"],
                      className: undefined,
                      component: undefined,
                      dropdownClassName: undefined,
                    },
                    fontSize: {
                      icon: undefined,
                      options: [11, 12, 13, 14, 18, 24],
                      className: undefined,
                      component: undefined,
                      dropdownClassName: undefined,
                    },
                  }}
                />
              </div>
              {/* <InputBox
                data={updateForm.closingDate}
                onChange={async (e) => {
                  e.preventDefault();
                  await handleChange(
                    e.target.value,
                    updateForm.closingDate.key
                  );
                }}
              /> */}
              <div className="job-date">
                {/* <label>Closing Date</label> */}
                {/* <Space direction="vertical">
                  <DatePicker
                    size="large"
                    style={{ width: "100%" }}
                    allowClear={true}
                    placement="bottomLeft"
                    onChange={onChangeDate}
                  />
                </Space> */}

                <DatePickerComponent data={updateForm.closingDate} />
                {selectJobs?.closing_date && updateForm.closingDate?.value && (
                  <div className="d-flex mt-2">
                    <Tag
                      data={{
                        type: "pending",
                        tagName: moment(updateForm.closingDate?.value).format(
                          "DD-MM-YYYY"
                        ),
                      }}
                    />
                  </div>
                )}
              </div>
              <InputBox
                data={updateForm.sourceURL}
                onChange={async (e) => {
                  e.preventDefault();
                  await handleChange(e.target.value, updateForm.sourceURL.key);
                }}
              />
              <div
                className="d-flex justify-content-end align-items-end mt-2"
                style={{
                  marginBottom: "-25px",
                  position: "relative",
                  zIndex: "90",
                }}
              >
                <Button
                  data={{
                    btnName: "Create New",
                    buttonType: "secondary s-border",
                    buttonSize: "xs x",
                    // isLoading: isLoading,
                  }}
                  onClick={(e) => {
                    dispatch(openCreateTagModal());
                  }}
                />
              </div>
              <TagsSelectBox
                onChangeTag={tagsSelect}
                tagList={selectedTagList || []}
                data={{
                  language: language,
                }}
              />

              <GazetteDateSelectBox
                onChangeGazette={gazetteDateSelect}
                data={{
                  type: "gazetteDate",
                }}
              />
              <InputBox
                data={updateForm.contactNo}
                onChange={async (e) => {
                  e.preventDefault();
                  await handleChange(e.target.value, updateForm.contactNo.key);
                }}
              />
              <InputBox
                data={updateForm.email}
                onChange={async (e) => {
                  e.preventDefault();
                  await handleChange(e.target.value, updateForm.email.key);
                }}
              />
              <div style={{ marginBottom: "10px" }}>
                <div className={"hne-cjw-uploader-lable"}>Job Details</div>

                <div className={"d-flex flex-column"}>
                  <div className={"d-flex flex-column align-items-center"}>
                    <div>
                      {/* {image?.si_url && (
                        <>
                          <ImageComponent
                            data={{
                              size: "md mt-3",
                              imgUrl: image?.si_url,
                              isPdf: image?.si_url?.endsWith(".pdf"),
                            }}
                            onClickRemove={() => {
                              if (selectJobs?.job_id) {
                                setImage((prev) => ({
                                  ...prev,
                                  si_url: "",
                                }));
                              } else {
                                onClickRemoveImage(
                                  image?.si_url?.file_name,
                                  "si",
                                  "image"
                                );
                              }
                            }}
                          />
                        </>
                      )} */}

                      {/* <Uploader
                        data={{
                          disabled: false,
                          isLable: true,
                          // uploaderLable: "Banner image (1000x 720)",
                          iconName: "upload-cloud",
                        }}
                        onChange={(imageData) => onChangeImage(imageData, "si")}
                      /> */}
                      {/* <PDFUploader
                        data={{
                          disabled: false,
                          isLable: false,
                          iconName: "upload-cloud",
                          // key: "pdfUploader",
                        }}
                        onChange={(imageData) => onChangeImage(imageData, "si")}
                      /> */}

                      <PDFUploader
                        data={{
                          disabled: false,
                          isLable: false,
                          iconName: "upload-cloud",
                          // key: "pdfUploader",
                        }}
                        onChange={(imageData) => onChangeImage(imageData, "si")}
                      />
                      <span className={"hne-cjw-lable"}>Sinhala</span>
                    </div>

                    {image?.si_url?.length > 0 && (
                      <PDFPreviewer
                        data={{
                          attachments: image?.si_url,
                          size: "lg mt-3",
                        }}
                        setPDFList={(imageData) => {
                          console.log("img", imageData);
                          setImage((prev) => ({
                            ...prev,
                            si_url: imageData || [],
                          }));
                        }}
                      />
                    )}
                  </div>

                  <div className={"d-flex flex-column align-items-center"}>
                    <div>
                      {/* {image?.en_url && (
                        <>
                          <ImageComponent
                            data={{
                              size: "md mt-3",
                              imgUrl: image?.en_url,
                              isPdf: image?.en_url?.endsWith(".pdf"),
                            }}
                            onClickRemove={() => {
                              if (selectJobs?.job_id) {
                                setImage((prev) => ({
                                  ...prev,
                                  en_url: "",
                                }));
                              } else {
                                onClickRemoveImage(
                                  image?.en_url?.file_name,
                                  "en",
                                  "image"
                                );
                              }
                            }}
                          />
                        </>
                      )}

                      <PDFUploader
                        data={{
                          disabled: false,
                          isLable: true,
                          // uploaderLable: "Banner image (1000x 720)",
                          iconName: "upload-cloud",
                        }}
                        onChange={(imageData) => onChangeImage(imageData, "en")}
                      /> */}

                      <PDFUploader
                        data={{
                          disabled: false,
                          isLable: false,
                          iconName: "upload-cloud",
                          // key: "pdfUploader",
                        }}
                        onChange={(imageData) => onChangeImage(imageData, "en")}
                      />
                      <span className={"hne-cjw-lable"}>English</span>
                    </div>

                    {image?.en_url?.length > 0 && (
                      <PDFPreviewer
                        data={{
                          attachments: image?.en_url,
                          size: "lg mt-3",
                        }}
                        setPDFList={(imageData) => {
                          setImage((prev) => ({
                            ...prev,
                            en_url: imageData || [],
                          }));
                        }}
                      />
                    )}
                  </div>

                  <div className={"d-flex flex-column align-items-center"}>
                    <div>
                      {/* {image?.ta_url && (
                        <>
                          <ImageComponent
                            data={{
                              size: "md mt-3",
                              imgUrl: image?.ta_url,
                              isPdf: image?.ta_url?.endsWith(".pdf"),
                            }}
                            onClickRemove={() => {
                              if (selectJobs?.job_id) {
                                setImage((prev) => ({
                                  ...prev,
                                  ta_url: "",
                                }));
                              } else {
                                onClickRemoveImage(
                                  image?.ta_url?.file_name,
                                  "ta",
                                  "image"
                                );
                              }
                            }}
                          />
                        </>
                      )}
                      <PDFUploader
                        data={{
                          disabled: false,
                          isLable: true,
                          // uploaderLable: "Banner image (1000x 720)",
                          iconName: "upload-cloud",
                        }}
                        onChange={(imageData) => onChangeImage(imageData, "ta")}
                      /> */}
                      <PDFUploader
                        data={{
                          disabled: false,
                          isLable: false,
                          iconName: "upload-cloud",
                          // key: "pdfUploader",
                        }}
                        onChange={(imageData) => onChangeImage(imageData, "ta")}
                      />
                      <span className={"hne-cjw-lable"}>Tamil</span>
                    </div>

                    {image?.ta_url?.length > 0 && (
                      <PDFPreviewer
                        data={{
                          attachments: image?.ta_url,
                          size: "lg mt-3",
                        }}
                        setPDFList={(imageData) => {
                          setImage((prev) => ({
                            ...prev,
                            ta_url: imageData || [],
                          }));
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
              <DropBox
                data={updateForm.jobApplicationType}
                onChange={(value) => {
                  const updateForm = { ...formData };
                  updateForm["jobApplicationType"].value = value;
                  setFormData(updateForm);
                  // dispatch(setCategoryDetails(e));
                }}
              />
              {selectJobs?.job_application_type &&
                updateForm.jobApplicationType.value && (
                  <div className="d-flex mt-2">
                    <Tag
                      data={{
                        type: "pending",
                        tagName: fetchApplicationType(
                          updateForm.jobApplicationType.value
                        ),
                      }}
                    />
                  </div>
                )}
              {formData.jobApplicationType.value === "1" && (
                <div>
                  <div
                    className={"hne-cjw-uploader-lable"}
                    style={{ marginTop: "12px" }}
                  >
                    Job Application
                  </div>

                  <div
                    className={"d-flex flex-row "}
                    style={{ gap: "10px", alignItems: "center" }}
                  >
                    <div
                      className={"d-flex flex-column "}
                      style={{ gap: "5px" }}
                    >
                      <div
                        className={"d-flex flex-row align-items-center"}
                        style={{ gap: "5px" }}
                      >
                        {jobApplication?.si_url && (
                          <>
                            <ImageComponent
                              data={{
                                size: "md mt-3",
                                imgUrl: jobApplication?.si_url,
                                isPdf: jobApplication?.si_url?.endsWith(".pdf"),
                              }}
                              onClickRemove={() => {
                                if (selectJobs?.job_id) {
                                  setJobApplication((prev) => ({
                                    ...prev,
                                    si_url: "",
                                  }));
                                } else {
                                  onClickRemoveImage(
                                    jobApplication?.si_url?.file_name,
                                    "si",
                                    "jobApplication"
                                  );
                                }
                              }}
                            />
                          </>
                        )}

                        <PDFUploader
                          data={{
                            disabled: false,
                            isLable: true,
                            // uploaderLable: "Banner image (1000x 720)",
                            iconName: "upload-cloud",
                          }}
                          onChange={(imageData) =>
                            onChangeJobApplication(imageData, "si")
                          }
                        />
                      </div>
                      <span className={"hne-cjw-lable"}>Sinhala</span>
                    </div>

                    <div
                      className={"d-flex flex-column"}
                      style={{ gap: "5px" }}
                    >
                      <div
                        className={"d-flex flex-row align-items-center"}
                        style={{ gap: "5px" }}
                      >
                        {jobApplication?.en_url && (
                          <>
                            <ImageComponent
                              data={{
                                size: "md mt-3",
                                imgUrl: jobApplication?.en_url,
                                isPdf: jobApplication?.en_url?.endsWith(".pdf"),
                              }}
                              onClickRemove={() => {
                                if (selectJobs?.job_id) {
                                  setJobApplication((prev) => ({
                                    ...prev,
                                    en_url: "",
                                  }));
                                } else {
                                  onClickRemoveImage(
                                    jobApplication?.en_url?.file_name,
                                    "en",
                                    "jobApplication"
                                  );
                                }
                              }}
                            />
                          </>
                        )}
                        <PDFUploader
                          data={{
                            disabled: false,
                            isLable: true,
                            // uploaderLable: "Banner image (1000x 720)",
                            iconName: "upload-cloud",
                          }}
                          onChange={(imageData) =>
                            onChangeJobApplication(imageData, "en")
                          }
                        />
                      </div>
                      <span className={"hne-cjw-lable"}>English</span>
                    </div>
                  </div>
                </div>
              )}
            </>
          </div>
        </Scrollbars>

        <div
          className="d-flex flex-row justify-content-between"
          style={{ marginBottom: "15px" }}
        >
          {selectJobs?.job_id && (
            <Button
              data={{
                btnName: "Clear",
                buttonType: "secondary mr-2",
                buttonSize: "lg",
                isLoading: isLoading,
              }}
              onClick={async (e) => {
                e.preventDefault();
                dispatch(clearedSelectJobs());
                clearAll();
              }}
            />
          )}

          <Button
            data={{
              btnName: selectJobs?.job_id ? "UPDATE" : "DONE",
              buttonType:
                updateForm.jobTitleEN.value === "" &&
                updateForm.jobTitleSI.value === ""
                  ? "primary disabled"
                  : "primary",
              buttonSize: "lg",
              isLoading: isLoading,
              disable:
                updateForm.jobTitleEN.value === "" &&
                updateForm.jobTitleSI.value === ""
                  ? true
                  : false,
            }}
            onClick={async (e) => {
              e.preventDefault();
              if (selectJobs?.job_id) {
                await onClickUpdate(e);
              } else {
                await onClickSave(e);
              }
            }}
          />
        </div>
      </div>
    </>
  );
};
export default withRouter(CreateNewJob);
